module.exports = __webpack_public_path__ + "static/img/fm9.89bcee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm9.jpg
// module id = +/E8
// module chunks = 1